import { datadogRum } from '@datadog/browser-rum'

import { ref } from 'vue'
import { DATADOG_CUSTOM_ACTIONS_NAMES } from '@/lib/consts.js'

export const DATADOG_LOGIN_METHODS = {
  TOKEN: 'token',
  EMAIL: 'email',
  GOOGLE: 'google',
  APPLE: 'apple',
  FACEBOOK: 'facebook',
}

export const DATADOG_LOGIN_ENDPOINTS = {
  ACCOUNT_EXISTS: 'account_exists',
  BUSINESS_DETAILS: 'business_details',
  LOGIN: 'login',
  BUSINESSES_LIST: 'businesses_list',
}

const isDuringLoginProcess = ref(false)
const loginMethod = ref(null)

export function useDatadogLoginActions () {
  const startLoginProcess = (method) => {
    isDuringLoginProcess.value = true
    loginMethod.value = method
  }

  const reportLoginAction = (data = {}) => {
    if (!isDuringLoginProcess.value) return

    const {
      isWorkingProperly,
      response,
      info,
    } = data

    const actionName = isWorkingProperly
      ? DATADOG_CUSTOM_ACTIONS_NAMES.LOGIN_WORKING_PROPERLY
      : DATADOG_CUSTOM_ACTIONS_NAMES.LOGIN_NOT_WORKING

    try {
      datadogRum.addAction(actionName, {
        login_method: loginMethod.value,
        ...(response && {
          status_code: response.status,
          error_message: response.data?.errors?.[0]?.description || response.message,
        }),
        ...(info && { info }),
      })
    } catch (e) { /* nothing */ }

    isDuringLoginProcess.value = false
    loginMethod.value = null
  }

  return {
    startLoginProcess,
    reportLoginAction,
  }
}
